import _ from 'lodash/fp'
import slugify from 'slugify'

/**
 * Slugify to lower snakecase. Apostrophe are converted to underscores
 * @param {string} input A string to slugify
 */
export const lowerSlugify = _.flow(_.curryRight(slugify)({ lower: true, replacement: '_' }), string => string.replace(/('|-)/g, '_'))
